/// <reference path="../types/index.d.ts" />

import '../client_forms/gourmetvendor/style.css';
import FormStructure from './gourmetvendor/form_structure';

export default FormStructure;